module.exports = __webpack_public_path__ + "img/logo-short.892cb832.png";